/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';

import { SortableList } from '@molecules';
import { Button } from '@atoms';

import { CHANNEL_FIELDS, CHANNEL_INITS, SCHEDULE_FIELDS } from './constants';
import AddChannelForm from './AddChannelForm';
import SlideItem from './SlideItem';
import Form from '../Form';
import s from './styles.module.less';

const EventChannels = ({ initialValues: initData, form: _form, dayIdx, days }) => {
  const [form] = Form.useForm(CHANNEL_FIELDS);
  const [open, setOpen] = React.useState(false);

  const initialValues = React.useMemo(() => form.deserialize({ ...CHANNEL_INITS }), [form]);

  const [channels, setChannels] = React.useState(initData.channels);

  const syncChannels = React.useCallback(
    (_channels) => {
      let newDays = days;
      let selectedDayValue = { ...newDays[dayIdx], channels: _channels };
      newDays[dayIdx] = selectedDayValue;

      _form.setFields([{ name: SCHEDULE_FIELDS.DAYS.name, value: newDays }]);
      setChannels(_channels);
    },
    [_form, dayIdx, days],
  );

  const handleAdd = React.useCallback((channel) => syncChannels([channel, ...channels]), [syncChannels, channels]);

  const handleClose = React.useCallback(() => {
    setOpen(false);
    form.resetFields();
  }, [form]);

  return (
    <>
      <div>
        <Button type="customBlue" onClick={() => setOpen(true)} style={{ marginBottom: 20 }}>
          ADD CHANNEL
        </Button>
      </div>
      {open && (
        <AddChannelForm
          initialValues={initialValues}
          handleClose={handleClose}
          className={s.addForm}
          onSubmit={handleAdd}
        />
      )}
      {!!channels?.length && (
        <div style={{ marginTop: 20 }}>
          <SortableList onChange={syncChannels} label="Channels" value={channels}>
            {(value, { edit, isEdit, save, buttons }) =>
              isEdit ? (
                <AddChannelForm handleClose={handleClose} initialValues={value} buttons={buttons} onSubmit={save} />
              ) : (
                <SlideItem handleEdit={edit}>{value?.title}</SlideItem>
              )
            }
          </SortableList>
        </div>
      )}
    </>
  );
};

export default EventChannels;
